import type { FunctionComponent } from "react";
import CompanyRiskFlag from "components/company/CompanyRiskFlag";

export interface CompanyRiskProps {
  id?: string;
  cid?: string;
}

const CompanyRisk: FunctionComponent<CompanyRiskProps> = function ({
  id,
  cid,
}) {
  return (
    <div className="flex flex-row items-center justify-center w-full">
      <CompanyRiskFlag id={id || cid} />
    </div>
  );
};

export default CompanyRisk;
